/**
 * ToolLibraryApi
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const CommonMeasurementSystemDto = {
  Undefined: 'Undefined',
  Metric: 'Metric',
  Imperial: 'Imperial',
} as const;

export type CommonMeasurementSystemDto =
  (typeof CommonMeasurementSystemDto)[keyof typeof CommonMeasurementSystemDto];
